(function (Drupal, $) {
  'use strict';

  function equalHeight () {
    $('.news__files > .field__item').matchHeight({ remove: true }).matchHeight({})
  }

  function setupHeaderMinHeight ($header) {
    const contentHeight = $header.find('.group-text').height()
    const imageHeight = $header.find('.news__background').height()

    $header.css({
      minHeight: Math.max(contentHeight + 40, imageHeight)
    })
  }

  function setupHeader () {
    const headers = $('.group-header .wrapper')

    headers.each(function (headerId, header) {
      const $header = $(header)

      setupHeaderMinHeight($header)
    })
  }

  $(window).off('resize.news').on('resize.news', function () {
    setupHeader()
  })

  Drupal.behaviors.news = {
    attach: function (context, settings) {
      equalHeight()
      setupHeader()
    }
  }

})(Drupal, jQuery)
